import { PRICING_PLAN } from 'components/pages/pricing/base/enumsPricing';
import { clamp } from 'ramda';
import { useRef } from 'react';
import { useSprings } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import { convertToPx } from 'utils/helper';

export default function useDragPlans({ length }) {
	const ITEM_WIDTH = convertToPx(10);
	const index = useRef(0);

	const [items, setItems] = useSprings(length, i => ({
		sc: 1,
		x: i * ITEM_WIDTH,
		display: 'block',
		opacity: '100%'
	}));

	const bind = useGesture({
		// xDir from left to right: -1
		// xDir from right to left: 1
		onDrag: ({ delta: [xDelta], down, direction: [xDir], distance, cancel }) => {
			// prevent animation from scrolling
			if (Math.abs(xDir) > 0.9 && distance < 150 && Math.abs(xDelta) > 2) {
				if (down) {
					index.current = clamp(0, PRICING_PLAN.LENGTH - 1, index.current + (xDir > 0 ? -1 : 1));
				}

				setItems((i) => {
					const x = (i - index.current) * ITEM_WIDTH + (down ? xDir * distance : 0);
					// const scale = down ? 1 - distance / ITEM_WIDTH / 2 : 1;

					if (i < index.current - 1 || i > index.current + 1) return { x, display: 'none', opacity: '0%' };
					return { x, display: 'block', opacity: i < index.current ? '0%' : '100%' };
				});
				cancel();
			}
		}
	});

	return {
		items,
		bind
	};
}
